module.exports = __webpack_public_path__ + "090122987c8164dbbc6329f9a9c73e33.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/city-28.png
 ** module id = 1019
 ** module chunks = 0
 **/